import script from "./SimCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimCard.vue?vue&type=script&lang=ts&setup=true"

import "./SimCard.vue?vue&type=style&index=0&id=2f872b7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f872b7c"]])

export default __exports__